import { render } from "./DeleteConfirmation.vue?vue&type=template&id=4079a383&scoped=true&ts=true"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=ts"

import "./DeleteConfirmation.vue?vue&type=style&index=0&id=4079a383&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4079a383"],['__file',"src/components/payoutAccounts/DeleteConfirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4079a383"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4079a383', __exports__)) {
    api.reload('4079a383', __exports__)
  }
  
  module.hot.accept("./DeleteConfirmation.vue?vue&type=template&id=4079a383&scoped=true&ts=true", () => {
    api.rerender('4079a383', render)
  })

}


export default __exports__